import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;
const dashboardUrl = `${apiPrefix}${v2}/dashboard`;

export default class DashboardService {
  constructor(client) {
    this.client = client;
  }

  async getDashboard(params = {}) {
    const response = await this.client.get(dashboardUrl, {
      params,
      paramsSerializer: (values) => {
        const searchParams = new URLSearchParams();

        Object.entries(values).forEach(([key, value]) => {
          if (value === undefined || value === null || value === '') return;
          const valuesToSerialize = Array.isArray(value) ? value : [value];
          valuesToSerialize.forEach((item) => searchParams.append(key, item));
        });

        return searchParams.toString();
      }
    });
    return response.data;
  }
}
